<div class="ipm-negotiation-header-wrapper">
    <h4>Negotiation: {{currentNegotiation?.currentRound}}</h4>
</div>
<div class="ipm-offer-section" #matDialogBox>
    <!-- <div class="ipm-close-icon" (click)="closePopup()">
        <i class="pi pi-times"></i>
    </div> -->
    <figure>
        <div class="ipm-img-wrapper">
            <img priority [src]="currentNegotiation?.beatDetails?.cover_picture"
            alt="user-icon" width="40" height="40">
        </div>
        <figcaption>
            <span class="ipm-beat-name">{{currentNegotiation?.beatDetails?.title}}</span>
            <span class="artist-name">
                {{currentNegotiation?.beatOwner?.name}}
                <!-- <img class="ipm-verify-icon" *ngIf="(currentBeatsDetails.producer.tiers | getSubsTires : 'producer') === 'tier1'" priority src="./assets/imgs/subs_premium_tick.svg"
                    alt="verify-icon">
                    <img class="ipm-verify-icon" *ngIf="(currentBeatsDetails.producer.tiers | getSubsTires : 'producer') === 'tier2'" priority src="./assets/imgs/subs_pro_tick_img.png"
                    alt="verify-icon"> -->
            </span>
        </figcaption>
    </figure>
    <div class="ipm-section-offer-list">
        <table class="ipm-custom-table">
            <thead>
                <tr>
                    <th></th>
                    <ng-container *ngFor="let headerItem of currentNegotiation?.tableHeader; let i = index">
                        <th [attr.colspan]="i === (currentNegotiation?.tableHeader.length - 1 ) && state !== 'start'? '2' : '0'">{{headerItem}}</th>
                    </ng-container>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let offerData of offerList; let i = index">
                    <ng-container *ngIf="offerData.label_Name !== 'Master Rights' || currentNegotiation?.hasMasterRights">
                    <tr>
                        <th>{{offerData.label_Name}}</th>
                        <td>
                            <span *ngIf="offerData.symbolType === 'price'; else OtherOption">
                                {{(offerData?.currentOffer?.value ? offerData?.currentOffer?.value : 0 ) | currency : 'INR' : 'symbol' : '1.0-0'}}
                            </span>
                            <ng-template #OtherOption>
                                <span *ngIf="offerData.symbolType === 'percentage'; else showBooleanString">
                                    {{((offerData?.currentOffer?.value ? offerData?.currentOffer?.value : 0) / 100) | percent : '0.0-0'}}
                                </span>
                            </ng-template>
                            <ng-template #showBooleanString>
                                <span>
                                    {{offerData?.currentOffer?.value ? offerData?.currentOffer?.value : 'Yes'}}
                                </span>
                            </ng-template>
                        </td>
                        <td class="ipm-patch-color" [class.not-fixed-width]="state !== 'start'">
                            <ng-container *ngIf="state === 'start'">
                                <div class="custom-form"  [class.ipm-price-static-symbol]="offerData.symbolType !== 'boolean'" [class.ipm-percentage-symbol]="offerData.symbolType === 'percentage'" >
                                <!-- <div class="custom-form"
                                *ngIf="offerData.symbolType === 'percentage' || offerData.symbolType === 'price' ; else showDropDown"> -->
                                    <div class="form-group custom-form-group position-relative">
                                        <input type="text"
                                            [id]="'input_'+i"
                                            class="form-control"
                                            autocomplete="off"
                                            [class.error-border-color]="!offerData?.isValid"
                                            (blur)="onInputBlur($event, i)"
                                            [pTooltip]="offerData.errorText"
                                            (keypress)="formService.keyPressNumber($event)"
                                            (keyup)=" !formService.keyPressNumber($event) ? offerData.formModel : ''"
                                            [maxLength]="offerData.symbolType === 'price' ? 7  : 2"
                                            [readOnly]="offerData.symbolType === 'boolean'"
                                            [(ngModel)]="offerData.formModel">
                                            <span  class="ipm-price-symbol">{{ offerData.symbolType === 'price' ?  '₹' : '%'}}</span>
                                    </div>
                                </div>
                                <!-- <ng-template #showDropDown>
                                    <div class="custom-form">
                                        <div class="form-group custom-form-group">
                                            <p-dropdown
                                                [className]="'ipm-dropdown'"
                                                id="creditsOption_{{i}}"
                                                [options]="creditsOption"
                                                [appendTo]="ipmPriceMainSection"
                                                [autoWidth]="true"
                                                [(ngModel)]="offerData.formModel"
                                                [ngModelOptions]="{standalone: true}" placeholder=""
                                                #ipmPriceMainSection>
                                            </p-dropdown>
                                        </div>
                                    </div>
                                </ng-template> -->
                                <i class="las la-undo-alt ms-2" (click)="actionPerform(i,'undo')" *ngIf="!this.state"></i>
                            </ng-container>
                        </td>
                        <td class="ipm-action-patch-color" [class.not-fixed-width]="state !== 'start'" *ngIf="!state">
                            <ng-container *ngIf="state !== 'start'">
                                <ng-container *ngIf="offerData.isAccepted && !offerData.isCounterEnable">
                                    <span class="accepted-text">Term accepted <i class="las la-undo-alt" (click)="actionPerform(i,'undo')" *ngIf="offerData.isAllowedInput"></i></span>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="offerData.isCounterEnable || state === 'start'">
                                <div class="d-flex justify-content-end align-items-center">
                                    <div class="custom-form"  [class.ipm-price-static-symbol]="offerData.symbolType !== 'boolean'" [class.ipm-percentage-symbol]="offerData.symbolType === 'percentage'" >
                                    <!-- <div class="custom-form"
                                    *ngIf="offerData.symbolType === 'percentage' || offerData.symbolType === 'price' ; else showDropDown"> -->
                                            <div class="form-group custom-form-group position-relative">
                                                <input type="text"
                                                    [id]="'input_'+i"
                                                    class="form-control"
                                                    autocomplete="off"
                                                    [class.error-border-color]="!offerData?.isValid"
                                                    (blur)="onInputBlur($event, i)"
                                                    [pTooltip]="offerData.errorText"
                                                    tooltipEvent="hover"
                                                    (keypress)="formService.keyPressNumber($event)"
                                                    (keyup)=" !formService.keyPressNumber($event) ? offerData.formModel : ''"
                                                    [tooltipOptions]="offerData.tooltipOptions"
                                                    tooltipPosition="top"
                                                    [maxLength]="offerData.symbolType === 'price' ? 7  : 2"
                                                    [(ngModel)]="offerData.formModel">
                                                    <span  class="ipm-price-symbol">{{ offerData.symbolType === 'price' ?  '₹' : '%'}}</span>
                                            </div>
                                        </div>
                                <!-- <ng-template #showDropDown>
                                    <div class="custom-form">
                                        <div class="form-group custom-form-group">
                                            <p-dropdown
                                                [className]="'ipm-dropdown'"
                                                id="creditsOption_{{i}}"
                                                [options]="creditsOption"
                                                [appendTo]="ipmPriceMainSection"
                                                [autoWidth]="true"
                                                [(ngModel)]="offerData.formModel"
                                                [ngModelOptions]="{standalone: true}" placeholder=""
                                                #ipmPriceMainSection>
                                            </p-dropdown>
                                        </div>
                                    </div>
                                </ng-template> -->
                                <i class="las la-undo-alt ms-2" (click)="actionPerform(i,'undo')" *ngIf="!this.state &&  offerData.isAllowedInput"></i>
                                    </div>
                            </ng-container>
                            <div class="table-action" *ngIf="state !== 'start' &&!offerData.isCounterEnable && !offerData.isAccepted">
                                <button class="btn ipm-btn ipm-accepted-btn" (click)="actionPerform(i,'accept')">
                                    Accept
                                </button>
                                <button class="btn ipm-btn ipm-counter-btn" (click)="actionPerform(i,'counter')">
                                    Counter
                                </button>
                            </div>
                        </td>
                    </tr>
                    </ng-container>
                </ng-container>
            </tbody>
        </table>

        <div class="ipm-action">
            <button class="btn ipm-btn counter-btn ipm-back-icon" (click)="onClickBackButton()" *ngIf="state === 'start'">
                Back
            </button>
            <button class="btn ipm-btn counter-btn" (click)="makeOfferIOrCounter()" >
                {{state === 'start' ? "Make Offer" : "Submit"}}
            </button>
        </div>
    </div>
</div>
